// extracted by mini-css-extract-plugin
module.exports = {"main":"success_main__1MhTk","title":"success_title__1PSYu","success":"success_success__3u-hJ"};